"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfWebSiteSettingSearchModel = instanceOfWebSiteSettingSearchModel;
exports.WebSiteSettingSearchModelFromJSON = WebSiteSettingSearchModelFromJSON;
exports.WebSiteSettingSearchModelFromJSONTyped = WebSiteSettingSearchModelFromJSONTyped;
exports.WebSiteSettingSearchModelToJSON = WebSiteSettingSearchModelToJSON;
exports.WebSiteSettingSearchModelToJSONTyped = WebSiteSettingSearchModelToJSONTyped;
/**
 * Check if a given object implements the WebSiteSettingSearchModel interface.
 */
function instanceOfWebSiteSettingSearchModel(value) {
    return true;
}
function WebSiteSettingSearchModelFromJSON(json) {
    return WebSiteSettingSearchModelFromJSONTyped(json, false);
}
function WebSiteSettingSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'name': json['name'] == null ? undefined : json['name'],
        'flag': json['flag'] == null ? undefined : json['flag'],
    };
}
function WebSiteSettingSearchModelToJSON(json) {
    return WebSiteSettingSearchModelToJSONTyped(json, false);
}
function WebSiteSettingSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'name': value['name'],
        'flag': value['flag'],
    };
}
